export class State {
    constructor(public stateCode: string, public stateName: string) { }
}
